import { Culture } from "../../../types/culture";

type ModalDefects2FooterProps = {
    translateString: (key: string, culture: Culture) => string;
    culture: Culture;
    handleYes: () => void;
    closeModal: () => void;
    saveButtonInactive: () => boolean;
};

const ModalDefects2Footer: React.FC<ModalDefects2FooterProps> = ({
    translateString,
    culture,
    handleYes,
    closeModal,
    saveButtonInactive
}) => {
    return (
        <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={closeModal}>
                {translateString("close", culture)}
            </button>
            <button type="button" className="btn btn-primary" onClick={handleYes} disabled={saveButtonInactive()}>
                {translateString("inBoundBtnOk", culture)}
            </button>
        </div>
    );
};

export default ModalDefects2Footer;
